import sistema from "./sistema/SistemaAudienciaTemporal.js"

const GestionAudiencias = {
    sistema: sistema
}

export default GestionAudiencias;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/AudienciasTemporal/AudienciasTemporalAPI.js
// module id = null
// module chunks = 